import { createFileRoute } from '@tanstack/react-router';
import { MediaPage } from 'src/pages/media';

export const Route = createFileRoute('/_protected/media/')({
  component: MediaPage,
});
